import React from 'react';
import PropTypes from 'prop-types';
import {
  CELSIUS_ID, FAHRENHEIT_ID, SPEED_FEET, SPEED_METERS,
} from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelValueRender';
import getChannelValueWithUnitsFromChannelKeyObjectString
  from '../../../../common/ChannelValueWithUnitsFromChannelKeyObject/getChannelValueWithUnitsFromChannelKeyObjectString';
// ... existing code ...
import { isSpecialChannel, getSpecialConditionLabel } from '../../../../../utility/alertDisplayUtils';

const cellStyle = {
  maxWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

// Renders an operator + value pairing. Used by both the Threshold column
// (trigger condition) and the Clear Value column (derived from hysteresis) —
// they have identical structure, only the operator symbol and value differ.
// For boolean/fault channels, renders a textual state instead.
const OperatorWithValueCell = ({
  alert, channel, channelKeyObject, operatorSymbol, value, specialIsTrigger, userPreferences,
}) => {
  const { temperatureScale = CELSIUS_ID } = userPreferences || {};

  if (isSpecialChannel(channel)) {
    const label = getSpecialConditionLabel(channel, alert, specialIsTrigger);
    return (
      <td className="align-middle" style={cellStyle} title={label}>
        {label}
      </td>
    );
  }
  const rendered = getChannelValueWithUnitsFromChannelKeyObjectString(
    temperatureScale,
    channelKeyObject,
    value,
    alert.customUnit,
  );
  const display = `${operatorSymbol} ${rendered}`;
  return (
    <td className="align-middle" style={cellStyle} title={display}>
      {display}
    </td>
  );
};
// ... existing code ...

OperatorWithValueCell.propTypes = {
  alert: PropTypes.shape({
    customUnit: PropTypes.string,
    startOperatorTypeId: PropTypes.number,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  channel: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  channelKeyObject: PropTypes.object.isRequired,
  operatorSymbol: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  specialIsTrigger: PropTypes.bool.isRequired,
  userPreferences: PropTypes.shape({
    temperatureScale: PropTypes.oneOf([CELSIUS_ID, FAHRENHEIT_ID]),
    airSpeedScale: PropTypes.oneOf([SPEED_METERS, SPEED_FEET]),
  }),
};

OperatorWithValueCell.defaultProps = {
  userPreferences: {
    temperatureScale: CELSIUS_ID,
    airSpeedScale: SPEED_METERS,
  },
};

export default OperatorWithValueCell;
